import React, { useCallback } from 'react';
import { useQueue } from 'contexts/QueueContext.tsx';
import './UndoButton.css';

interface UndoButtonProps {
  className?: string;
  style?: React.CSSProperties;
}

const UndoButton: React.FC<UndoButtonProps> = ({ className, style }) => {
  // Use the unified queue system for undo functionality
  const {
    requestUndo,
    canUndo,
    hasFailedOperations,
    clearFailedOperations,
    clearQueue,
  } = useQueue();

  // Handle undo button click
  const handleUndo = useCallback(() => {
    requestUndo();
  }, [requestUndo]);

  // Handle clearing failed operations
  const handleClearFailed = useCallback(() => {
    clearFailedOperations();
  }, [clearFailedOperations]);

  // Handle clearing entire queue (for debugging)
  const handleClearQueue = useCallback(() => {
    if (window.confirm('Clear entire queue? This will remove all pending operations.')) {
      clearQueue();
    }
  }, [clearQueue]);

  return (
    <div className={className} style={style}>
      <button
        className={`undo-button ${canUndo ? 'undo-button--enabled' : 'undo-button--disabled'}`}
        disabled={!canUndo}
        onClick={handleUndo}
        title={canUndo ? 'Undo last stock change' : 'Nothing to undo'}
      >
        ↺ Undo
      </button>
    </div>
  );
};

export default UndoButton; 